var _mask, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnAnnouncement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_7785_181234",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8428 12.2551C27.5094 11.8744 28.3389 12.3565 28.3389 13.1242V27.6769C28.3389 28.4447 27.5094 28.9268 26.8428 28.5461L21.3389 25.4006H12C10.8954 25.4006 10 24.5051 10 23.4006V17.4006C10 16.296 10.8954 15.4006 12 15.4006H21.3389L26.8428 12.2551Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8428 12.2551L26.0989 10.9525L26.0985 10.9527L26.8428 12.2551ZM26.8428 28.5461L26.0985 29.8484L26.0989 29.8486L26.8428 28.5461ZM21.3389 25.4006L22.0831 24.0982L21.7373 23.9006H21.3389V25.4006ZM10 17.4006L8.5 17.4006V17.4006H10ZM21.3389 15.4006V16.9006H21.7373L22.0831 16.7029L21.3389 15.4006ZM26.8428 12.2551L27.5867 13.5576C27.2519 13.7488 26.8389 13.5064 26.8389 13.1242H28.3389H29.8389C29.8389 11.2065 27.7669 9.99991 26.0989 10.9525L26.8428 12.2551ZM28.3389 13.1242H26.8389V27.6769H28.3389H29.8389V13.1242H28.3389ZM28.3389 27.6769H26.8389C26.8389 27.2948 27.2519 27.0523 27.5867 27.2435L26.8428 28.5461L26.0989 29.8486C27.7669 30.8013 29.8389 29.5946 29.8389 27.6769H28.3389ZM26.8428 28.5461L27.5871 27.2438L22.0831 24.0982L21.3389 25.4006L20.5946 26.7029L26.0985 29.8484L26.8428 28.5461ZM21.3389 25.4006V23.9006H12V25.4006V26.9006H21.3389V25.4006ZM12 25.4006V23.9006C11.7239 23.9006 11.5 23.6767 11.5 23.4006H10H8.5C8.5 25.3336 10.067 26.9006 12 26.9006V25.4006ZM10 23.4006H11.5V17.4006H10H8.5V23.4006H10ZM10 17.4006L11.5 17.4006C11.5 17.1244 11.7239 16.9006 12 16.9006V15.4006V13.9006C10.067 13.9006 8.50001 15.4676 8.5 17.4006L10 17.4006ZM12 15.4006V16.9006H21.3389V15.4006V13.9006H12V15.4006ZM21.3389 15.4006L22.0831 16.7029L27.5871 13.5574L26.8428 12.2551L26.0985 10.9527L20.5946 14.0982L21.3389 15.4006Z",
    fill: "#172664",
    mask: "url(#path-2-inside-1_7785_181234)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4194 24.75V29.5C17.4194 30.4665 16.6359 31.25 15.6694 31.25C14.7029 31.25 13.9194 30.4665 13.9194 29.5V24.75H17.4194Z",
    stroke: "#172664",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1694 20.5H33.1694",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1694 16L33.1694 15",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1694 25L33.1694 26",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnAnnouncement);
export default __webpack_public_path__ + "static/media/btn_announcement.8da512a397ed41b9d7b108664068fffc.svg";
export { ForwardRef as ReactComponent };